import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Input from '../components/FormModal';
import Alerta from "../components/Alerta"
import { apagaAlertaLogin, loginADM, tokenLoginADM } from "./actions";

function LoginADM(props) {

    let [emailInput, setEmailInput] = useState("")
    let [senhaSemCripto, setSenhaSemCripto] = useState("")
    let [showPassword, setShowPassword] = useState(false)

    const dispatch = useDispatch()

    function handleLogin(event) {
        event.preventDefault();
        dispatch(loginADM(emailInput, senhaSemCripto))
    }

    useEffect(() => {
        let token = localStorage.getItem('TokenADM')
        dispatch(tokenLoginADM(token))
    })

    return (
        <div className={`${props.tema === 'escuro' ? 'bg-black text-white' : 'text-black'}`}>
            <div className={`
            min-h-screen  container
        `}>
                <Alerta />
                <div className="row cont-login">

                    <Alerta texto='Senha ou usuário inválido' status='erro' show={props.loginErro} apagaAlerta={() => dispatch(apagaAlertaLogin())} />

                    <div className="col flex items-center justify-center border-r border-slate-700">
                        <img src={process.env.PUBLIC_URL + '/tools-ori.png'} className='max-w-xs' />
                    </div>

                    <div className="col justify-center items-center">
                        <form action="" className="flex items-center justify-center flex-col h-full w-full" onSubmit={handleLogin}>
                            <Input value={emailInput} onChange={e => setEmailInput(e.target.value)} type='email' label='Email' placeholder='' className='text-2xl mb-4 w-5/6' />
                            <div className="relative w-5/6 mb-5">
                                <Input 
                                    value={senhaSemCripto} 
                                    onChange={e => { setSenhaSemCripto(e.target.value) }} 
                                    type={showPassword ? 'text' : 'password'} 
                                    label='Senha' 
                                    placeholder='' 
                                    className='text-2xl w-full pr-0'
                                />
                                <button 
                                    type="button"
                                    className="absolute inset-y-0 right-0 pr-0 flex items-center text-sm leading-5 mt-10 text-black button-login-adm"
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    <i className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                </button>
                            </div>
                            <button className="bg-blue-600 hover:bg-sky-600 text-lg py-2 w-5/6 rounded-md">Fazer Login</button>
                            <p className="text-slate-500 mt-3 hover:text-slate-500">Painel Administrador</p>
                        </form>
                    </div>

                </div>

            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        tema: state.appReducer.tema,
        loginErro: state.admReducers.loginErro
    }
}


export default connect(mapStateToProps, null)(LoginADM)

